/**
 *  Component - SelectedEmployeeCard
 *
 *  @param {empName} EmpName displayed at center
 *  @param {empId} EmpId shown below EmpName
 *  @param {empMail} EmpMail shown below EmpId
 *  @param {dates} Dates shown below EmpMail
 *  @param {lop} Lop shown at the right corner (no of days for LOP/RLOP)
 *  @param {typeOfPay} TypeOfPay shown at the right corner below Lop (type of pay loss eg: LOP or RLOP)
 *
 * Usage:
 * <!--
 *  <selected-employee-card
 *      empName="Chetna Garg"
 *      empId="745432"
 *      empMail="ChetnaGarg@gmail.com"
 *      dates="01,04/04/2018"
 *      joiningDate="24/04/2019" (will be shown if you give showJoiningDate=true default value is false)
 *      showJoiningDate=true
 *      lastLogin="24-Jun-2019 10:35PM"
 *      lop="02"
 *      typeOfPay="LOP"
 *      @click="{function_name}"
 *  >
 *  </selected-employee-card>  -->
 *
 */

<template>
    <div class="">
        <div class="card">
            <div class="image">
                <img v-if="empPhotoUrl" :src="empPhotoUrl" class="alignImage">
                <img v-else src="@/assets/user.svg" class="alignImage">
            </div>
            <div class="emp-details">
               <slot name="empDetails"> 
                    <span> <b> {{ empName }} </b> </span><br>
                    <span class="details"><b>{{ empId }}</b>  </span><br>
                    <span class="details" v-show="showJoiningDate"> <b>Joining Date : {{ joiningDate }}</b> </span><br>
                    <span class="details" v-show="showJoiningDate"> <b>CTC : {{ currCTC }}</b> </span><br>
                    <span class="details"> <b>Email ID :  {{ empMail }}</b> </span><br><br>
                    <span class="details" v-if="dates"> Month : <b>{{ dates }}</b> </span>
                    <br v-if="!showJoiningDate">
                    <span class="details" v-show="false"> Last Login : <b>{{ lastLogin }}</b> </span>
                </slot>
            </div>
            <div class="lop-details" v-if="lop">
                <span class="lop">  {{ lop }}  </span><br>
                <span class="details"> {{ typeOfPay }} </span>
            </div>
            
            <div class="close-card" v-if="closable" v-on:click="$emit('click')">
                <span> x </span>
            </div>
        </div>
        <!-- <div class="bottom-buttons" v-if="showJoiningDate">
            <button class="export-button" @click="$emit('generateSend')"> 
                <span> Send </span> 
            </button>
            <button class="export-button" @click="$emit('generateView')"> 
                <span> View </span>
            </button>
        </div> -->
     </div>
</template>

<script>
export default {
    name: 'SelectedEmployeeCard',
    props: {
        empPhotoUrl : {
            type: String
        },
        empName : {
            type: String
        },
        empId: {
            type: String
        },
        empMail: {
            type: String
        },
        lop: {
            type: Number
        },
        dates: {
            type: String 
        },
        typeOfPay: {
            type: String
        },
        currCTC: {
            type: String
        },
        revisedCTC: {
            type: String
        },
        effDate: {
            type: String
        },
        joiningDate: {
            type: String
        },
        showJoiningDate: {
            type: Boolean,
            default: false
        },
        lastLogin : {
            type: String
        },
        closable:{
            type:Boolean,
            default: true
        }
    },

}
</script>

<style lang="scss" scoped>
.card-container {
    height: 180px;
    width: 370px;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
}
.card {
  display: flex;
  width: 370px;
  margin-right: 12px;
  min-height: 125px;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  position: relative;
}
.image{
    .alignImage {
        width: 85px;
        height: 85px;
        margin: 24px 0 0 20px;
        border-radius: 50px;
    }
}
.emp-details {
    padding: 25px 0 0 30px;
    color: #535353;
}
.details {
    color: #979797;
    font-size: 11px;
        b {
            color: #535353;
        }
}
.joiningdetails {
    color: #979797;
    margin-bottom: 5%;
        font-size: 11px;
            b {
                color: #535353;
            }   
}
.lop-details {
    padding: 30px 0 0 30px;

    .lop {
        font-size:24px;
        color: #313131;
    }
}
.close-card {
    position: absolute;
    cursor: pointer;
    color: #5d409f;
    right: 10px;
    top: 4px;
}

</style>
